export const SET_LOADING = 'SET_LOADING'
export const SET_AUTH_STATE_VALUE = 'SET_AUTH_STATE_VALUE'
export const SET_AUTHORIZATION_ID = 'SET_AUTHORIZATION_ID'
